'use client';

import { useCallback } from 'react';

import { useDrawerStore, useModalStore } from '@/stores';
import type { PromotionOffer } from '@/utils';

import { PostGameUpsellModal } from '../PostGameUpsellModal';

import type { UpsellVariant } from '../hooks';

export type ShowPostGameUpsellParams = {
  raffleId: string;
  raffleName: string;
  offer: PromotionOffer;
  ticketPrice: number;
  gameTitle: string;
  variant?: UpsellVariant;
  onDismiss?: () => void;
};

export const usePostGameUpsell = () => {
  const openModal = useModalStore((state) => state.openModal);
  const closeModal = useModalStore((state) => state.closeModal);
  const closeCurrentDrawer = useDrawerStore((state) => state.closeCurrentDrawer);

  const showPostGameUpsell = useCallback(
    ({
      raffleId,
      raffleName,
      offer,
      ticketPrice,
      gameTitle,
      variant,
      onDismiss,
    }: ShowPostGameUpsellParams) => {
      closeCurrentDrawer();

      const modalId = openModal({
        showCloseButton: false,
        hardClose: variant === 'pre_game',
        priority: 90,
        className: '!h-auto !max-h-none w-full max-w-md mx-auto my-auto p-4',
        Component: () => (
          <PostGameUpsellModal
            raffleId={raffleId}
            raffleName={raffleName}
            offer={offer}
            ticketPrice={ticketPrice}
            gameTitle={gameTitle}
            variant={variant}
            onClose={() => closeModal(modalId)}
            onDismiss={onDismiss}
          />
        ),
      });

      return modalId;
    },
    [openModal, closeModal, closeCurrentDrawer],
  );

  return { showPostGameUpsell };
};
